import { UserPlus } from "@phosphor-icons/react";
import AvatarCharacter from "components/avatar-character";
import { Button } from "components/ui/buttons";
import { useModal } from "context/ModalContext";
import { useCallback, useEffect, useState } from "react";
import { getListOfFriends } from "services/friends.service";
import { useAppStore } from "store";
import FriendListItem from "./list-item";

type FriendsListProps = {
  onFriendClick: (friend: any) => void;
};

export default function FriendsList({ onFriendClick }: FriendsListProps) {
  const { user } = useAppStore();
  const { showModal } = useModal();
  const [friends, setFriends] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadFriends = useCallback(async () => {
    try {
      if (!user) return;
      const result = await getListOfFriends(user?._id);
      setFriends(result || []);
      setLoading(false);
    } catch (error) {
      //
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    loadFriends();
  }, [loadFriends]);

  function renderNoFriends() {
    return (
      <>
        <div className="absolute bottom-0 md:relative w-[270px] mt-[100px] md:mt-auto ml-[-150px]">
          <AvatarCharacter responsive />
        </div>

        <div className="absolute right-4 md:right-10 bottom-64 md:bottom-20 w-[36vw] md:w-[15vw] animate-fly-fast delay-200">
          <div className="absolute right-0 bottom-full mb-5 bg-white w-[90vw] md:w-96 rounded-xl shadow p-5 space-y-2 text-center">
            <p>Aún no has invitado a ningún amigo.</p>
          </div>
        </div>
      </>
    );
  }

  function renderFriends() {
    return (
      <div className="scroll-menu w-full max-h-full flex flex-col md:grid md:grid-cols-2 overflow-y-auto gap-1 p-1 items-start">
        {friends.map((friend: any) => (
          <FriendListItem
            key={friend._id}
            friend={friend}
            onClick={() => onFriendClick(friend)}
          />
        ))}
      </div>
    );
  }

  if (loading) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        Cargando...
      </div>
    );
  }

  return <>{friends.length === 0 ? renderNoFriends() : renderFriends()}</>;
}
